// ************************************************************************************************
// pathname: /v1/interview/answer/{id}
// ************************************************************************************************
import { useSwrMutationApi } from 'src/hooks/useSwrApi';

interface UseSwrInterviewAnswerDeleteProps {
  answerId: string;
  locale: string;
  successCallback?: (answerId: string) => void;
  errorCallback?: () => void;
}

/**
 * @description SWR mutation: Delete own interview answer (text/audio, mini-interview list).
 * @param answerId - string. The ID of the interview answer to delete.
 * @param locale - string. The locale to use for the request. Default: 'ro'.
 * @param successCallback - function. The callback to call on success.
 * @param errorCallback - function. The callback to call on error.
 */
export const useSwrInterviewAnswerDelete = (
  props: UseSwrInterviewAnswerDeleteProps,
) => {
  const {
    answerId, locale = 'ro', successCallback, errorCallback,
  } = props;

  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<undefined, never>({
    url: `/v1/interview/answer/${answerId}`,
    locale,
    fetcherConfig: {
      method: 'DELETE',
    },
    apiOptions: {
      onSuccess: () => successCallback?.(answerId),
      onError: () => errorCallback?.(),
    },
    toastsOptions: {
      showSuccessToast: true,
      showErrorToast: true,
    },
  });

  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};
